import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import postsdata from '../posts_data.json';
import {trigger, transition, animate, style, state, group} from '@angular/animations';

@Component({
  selector: 'app-posts',
  templateUrl: './posts.component.html',
  styleUrls: ['./posts.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({height: '*', opacity: 0})),
      transition(':leave', [
        style({height: '*', opacity: 1}),

        group([
          animate(300, style({height: 0})),
          animate('1s ease-out', style({ opacity: '0'}))
        ])

      ]),
      transition(':enter', [
        style({height: '0', opacity: 0}),

        group([
          animate(300, style({height: '*'})),
          animate('400ms ease-out', style({ opacity: '1'}))
        ])

      ])
    ])
  ]
})
export class PostsComponent implements OnInit {

  selectedJobId = '1';
  public postsdata: { id: string, category: string, title: string, creator: string, date: string, imagepath: string} [] = postsdata;
  nextJob = null;
  visible = true;
  constructor(public route: ActivatedRoute, public router: Router) { }

  ngOnInit() {
    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      if (paramMap.has('postId')) {
        this.selectedJobId = paramMap.get('postId');
        this.getNextPost(this.selectedJobId);
        window.scrollTo(0, 0);
      }
    });
  }

  closePopup() {
    this.visible = false;
    this.router.navigate(['blog']);
  }
  getNextPost(currentPostid: string) {
    const numid = parseInt(currentPostid, 10);
    if (numid < postsdata.length) {
      this.nextJob = postsdata[numid];
    } else {
      this.nextJob = postsdata[0];
    }
  }

}
